import * as React from 'react'
import ApiCall from '../../components/ApiCall/ApiCall'
import {Alert} from 'react-bootstrap'
import Header from '../structure/Header/Header'
import Footer from '../structure/Footer/Footer'
require('./resume.css')
interface ResumeProps
{
    location: any;
}

interface ResumeStats
{
    params : any,
    [key : string]: any,
    moyFraud : number,
    moyGood : number,
    message : string
}

export default class Resume extends React.Component<ResumeProps, ResumeStats> {
    
    private api = new ApiCall()
    constructor(props: ResumeProps) {
        super(props);
        this.state = {
            params : new URLSearchParams(this.props.location.search),
            cgu : [],
            moyFraud : 0,
            moyGood : 0,
            message : ''
        };
    }
    
    writeError() {
        let { error, message } = this.state

        if (error === true) {
            return (
                <>
                    <Alert variant="danger">
                        {message}
                    </Alert>
                </>
            );
        } else if (message !== "") {
            return (
                <>
                    <Alert variant="success">
                        {message}
                    </Alert>
                </>
            );
        }
    }

    // WEIRD
    componentDidMount = async () => {
        var totalFrauduleuse = 0;
        var totalGood = 0;
        const request = await this.api.ApiCall("websites?details=true&q=" + this.state.params.get('site'), "GET", {}, localStorage.getItem('AccessToken'))
		if(request.status === 200)
		{
            request.data.cgu.map((cgu:any) => {
                totalFrauduleuse += cgu.fraudulent;
                totalGood += cgu.good;
                return null;
            })
			this.setState({
                moyGood : totalGood,
                moyFraud : totalFrauduleuse,
                cgu : request.data.cgu
			})
		}
        if(request.status === 202){
            this.setState({
                error: false,
                message: "Nous sommes actuellement en train d'analyser le site web. Veuillez patienter quelques instants..."
            })
        }
        if(request.status === 400){
            this.setState({
                error: true,
                message: "Veuillez entrer une URL correcte pour pouvoir analyser un site."
            })
        }
		else {
			/*redirect accueil*/
            // window.location.href = "/"
		}
    }
    
	render() {
		return (
			<>	
				<div id="Top-Acc">
					<Header/>
                    <section id="resume-section" className="ftco-section">
                    {this.writeError()}
                        <div className="container">
                            <div id="row-justify" className="row justify-content-center mb-12 pb-5">
                                <div className="col-md-12 text-center heading-section ftco-animate">
                                    <span className="subheading">Nombres de clauses</span>
                                    <div id="justify-center-clause" className="row justify-content-center">
                                        <div id="frauduleuse_1">
                                            <div id="frauduleuse_2">Frauduleuses</div>
                                            <div id="frauduleuse_3">{this.state.moyFraud}</div>
                                        </div>
                                        <div id="modere_1">
                                            <a href={"clauses?site=" + this.state.params.get('site')} id="clause_anchor">
                                                Voir les clauses
                                            </a>
                                        </div>
                                        <div id="correct_1">
                                            <div id="correct_2">Correctes</div>
                                            <div id="correct_3">{this.state.moyGood}</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                </section>
				<Footer/>
				</div>
			</>
		);
    }
}